import { NAV_PATHS } from '@modules/common/constants';
import { ArrowBackRounded } from '@mui/icons-material';
import { IconButton, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface WorkspaceSettingsHeaderProps {
  isOnboardingPageVariant: boolean;
}

export const WorkspaceSettingsHeader = ({
  isOnboardingPageVariant,
}: WorkspaceSettingsHeaderProps) => {
  const navigate = useNavigate();

  return (
    <Stack
      direction="row"
      spacing={2}
      alignItems="center"
      sx={{
        px: 3.5,
        borderBottom: '1px solid',
        borderColor: 'divider',
        py: 2,
      }}
    >
      {isOnboardingPageVariant && (
        <IconButton
          onClick={() => {
            navigate(`/${NAV_PATHS.ONBOARD_TENANT_ADD_INTEGRATIONS}`);
          }}
        >
          <ArrowBackRounded
            fontSize="large"
            sx={{
              color: 'text.secondary',
            }}
          />
        </IconButton>
      )}
      <Typography variant="h4">Workspace Settings</Typography>
    </Stack>
  );
};

export default WorkspaceSettingsHeader;
